import type { AdminPanelService } from "~/entities/admin-panel/@x/di";
import type { AuthService } from "~/entities/auth/@x/di";
import type { EventBus } from "~/entities/event-bus/@x/di";
import type { ImageService } from "~/entities/image/@x/di";
import type { InquiryService } from "~/entities/inquiry/@x/di";
import type { NotificationService } from "~/entities/notification/@x/di";
import type { OrderService } from "~/entities/order/@x/di";
import type { ReviewService } from "~/entities/review/@x/di";
import type { ServiceCategoryService } from "~/entities/service-category/@x/di";
import type { ServiceService } from "~/entities/service/@x/di";
import type { UserRoleService } from "~/entities/user-role/@x/di";
import type { UserService } from "~/entities/user/@x/di";
import { createContextWithDisplayName, createUseNullableContext } from "~/shared/react";

type DiContainer = {
  serviceService: ServiceService;
  serviceCategoryService: ServiceCategoryService;
  orderService: OrderService;
  adminPanelService: AdminPanelService;
  authService: AuthService;
  userService: UserService;
  userRoleService: UserRoleService;
  inquiryService: InquiryService;
  reviewService: ReviewService;
  notificationService: NotificationService;
  imageService: ImageService;
  eventBus: EventBus;
};

const DiContainerContext = createContextWithDisplayName<DiContainer | null>(
  null,
  "DiContainerContext",
);

const useDi = createUseNullableContext(DiContainerContext);

export { DiContainerContext, useDi };
export type { DiContainer };
